angular.module('zc.zenclerkS')
  .component('zcsFooter', {
    templateUrl: '/templates/zenclerk_s/layout/footer.html',
    controllerAs: 'vm',
    controller: zcsFooter,
  });

zcsFooter.$inject = [];

function zcsFooter() {
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/footer.js